export enum Layout {
  Report,
  ReportSettings,
  Intermediate,
  Mfa,
}
